import React from 'react';
import 'assets/scss/desktop-navigation-bar.scss';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { Navurls, WORDPRESS_LINKS } from 'constants/links/NavLinks';

export const DesktopNavigatorbar = () => {
	return (
		<nav className="body desktop-navigator-container">
			<ul className="nav-container">
				{WORDPRESS_LINKS.map((link: Navurls, index) => {
					return (
						<li
							key={`link_element_${link.title}-${index}`}
							className={`${link.isContentSubLink ? 'nav-multicontent' : ''}`}
						>
							{link.isContentSubLink ? (
								<>
									<div style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
										
									}}>
										{link.title}{' '}
										<ArrowDropDownIcon
											style={{
												color: '#fff',
												alignSelf: 'center',
											}}
										/>
									</div>
									<ul key={`ul_container_${link.title}}-${index}`}>
										{link.subLinks?.map((subLink: Navurls, subIndex) => {
											return (
												<li key={`sublink_${subIndex}_${subLink.title}`}>
													<a key={`sublink_a_${subIndex}_${subLink.title}`} href={subLink.url}>
														{subLink.title}
													</a>
												</li>
											);
										})}
									</ul>
								</>
							) : (
								<a key={`link_a_${index}`} href={link.url}>
									{link.title}
								</a>
							)}
						</li>
					);
				})}
			</ul>
		</nav>
	);
};
